<kendo-grid [data]="generateWarrantyGridData"
            class="generateWarrantyGridCls"
            [sortable]="true"
            [selectable]="false"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="true"
            [sort]="generateWarrantyGridstate.sort"
            [pageable]="{ buttonCount: 5, info: true, responsive: true, pageSizes:[50,75,100] }"
            [pageSize]="generateWarrantyGridstate.take"
            [skip]="generateWarrantyGridstate.skip"
            [columnMenu]="{ filter: false, sort: false }"
            (sort)="generateWarrantyGridSortChange($event)"
            (pageChange)="generateWarrantyGridPageChange($event)"
            (columnReorder)="onReorder($event)"
            (columnVisibilityChange)="onVisibilityChange($event)"
            (dataStateChange)="generateWarrantyDataStateChange($event)"
            [filter]="gridSettings.state.filter"
            [loading]="generateWarrantyLoading">
  <ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
        {{warrantyLblText.exportToExcelLbl?warrantyLblText.exportToExcelLbl:generateWarranty.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
        {{warrantyLblText.exportToPdfLbl?warrantyLblText.exportToPdfLbl:generateWarranty.exportToPdfLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
    <div class="row pwaGenerateWarrantySearch " style="width:100%;">
      <div class="col-sm-3 col-md-2 paddingZero" style="padding-top:2px;">
        {{generateWarranty.orderDateLbl}}:
      </div>
      <div class="col-sm-9 col-md-5  paddingZero paddingRight-10">
        <app-grid-daterange-pwa-filter class="date-range-filter"
                                       [filter]="gridSettings.state.filter"
                                       field="orderDateAsDate">
        </app-grid-daterange-pwa-filter>
      </div>
      <div class="col-sm-12 col-md-5  paddingZero">
        <input placeholder="Search in all columns..."
           kendoTextBox
           (input)="onFilterGenerateWarranty($event.target.value)" class="searchClass" [(ngModel)]="searchTextGenerateWarranty" />

      </div>

    </div>
    <input placeholder="Search in all columns..."
           kendoTextBox
           (input)="onFilterGenerateWarranty($event.target.value)" class="pwaGenerateWarrantySearch" />
  </ng-template>

  <kendo-grid-column media="(max-width: 1024px)" title="Generate Warranty">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row" style="width:100%">
        <div class="col-12 col-md-3 paddingZero">
          <span class="txt-bold">{{dataItem.jobNumber}} - </span> {{dataItem.jobName}}
        </div>
        <div class="col-12 col-md-3 paddingZero">
          <span class="txt-bold">{{generateWarranty.serviceOrderLbl}} : </span> {{dataItem.serviceOrderNumber}}
        </div>
        <div class="col-6 col-md-3 paddingZero">
          <span class="txt-bold">{{generateWarranty.orderDateLbl}} : </span> {{dataItem.orderDateUIString}}
        </div>
        <div class="col-6 col-md-3 paddingZero">
          <span class="txt-bold">{{generateWarranty.scheduleDateLbl}} : </span> {{dataItem.scheduleDateUIString}}
        </div>
        <div class="col-6 col-md-3 paddingZero">
          <span class="txt-bold">{{generateWarranty.poLbl}} : </span> {{dataItem.poNumber}}
        </div>
        <div class="col-6 col-md-3 paddingZero">
          <span class="txt-bold">{{generateWarranty.shipFromLbl}} : </span> {{dataItem.shipFrom}}
        </div>
        <div class="col-10 col-md-3 paddingZero">
          <button class="k-button" kendoButton *ngIf="!popDialogue" (click)="openDialogue(dataItem)" [hidden]="dataItem.serviceOrderNumberProgress">
            {{warrantyLblText.relatedServiceLbl?warrantyLblText.relatedServiceLbl:generateWarranty.relatedServiceLbl}}
          </button>
        </div>
        <div class="col-2 col-md-3" style="padding-top:5px;">
          <button type="button" (click)="downloadWarranty(dataItem)"
                  [disabled]="dataItem.downloadProgress">
            <span class="k-icon k-i-download"></span>
            <kendo-loader *ngIf="dataItem.downloadProgress" style="color:blue"></kendo-loader>
          </button>
        </div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                     [field]="col.field"
                     [title]="col.title"
                     [width]="col._width"
                     [filter]="col.filter"
                     [filterable]="col.filterable"
                     [hidden]="col.hidden"
                     [format]="col.format" media="(min-width: 1025px)">
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'serviceOrderNumber'">
      {{dataItem.serviceOrderNumber}}
      <button kendoButton *ngIf="!popDialogue" (click)="openDialogue(dataItem)" [hidden]="dataItem.serviceOrderNumberProgress">
        {{warrantyLblText.relatedServiceLbl?warrantyLblText.relatedServiceLbl:generateWarranty.relatedServiceLbl}}
      </button>
      <kendo-loader *ngIf="(dataItem.serviceOrderNumberProgress)" style="color:blue"></kendo-loader>
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
    </ng-template>

    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'downloadWarranty'">
      <!--<a class="link" (click)="downloadWarranty(dataItem)"><button kendobutton type="button" id=".myButton"><span class="k-icon k-i-download"></span></button></a>-->
      <button class="k-button k-grid-remove-command" type="button" (click)="downloadWarranty(dataItem)"
              [disabled]="dataItem.downloadProgress">
        <span class="k-icon k-i-download"></span>
        <kendo-loader *ngIf="dataItem.downloadProgress" style="color:blue"></kendo-loader>
      </button>
    </ng-template>


    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'orderDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="orderDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'scheduleDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="scheduleDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>

  <!--
    <kendo-grid-column field="orderNumber"
                       title="{{orderInquiryGridColumnLbl.orderNumber}}"
                       [filterable]="true">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
        <a class="link" [routerLink]="['/order-inquiry/order-detail']" (click)="orderDetail(dataItem.orderNumber)">{{dataItem.orderNumber}}</a>
        <kendo-filter-contains-operator></kendo-filter-contains-operator>

      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderType"
                       title="{{orderInquiryGridColumnLbl.orderType}}"
                       [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="orderDateAsDate" filter="date" format="{0:d}"
                       title="{{orderInquiryGridColumnLbl.orderDate}}" [width]="220">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="orderDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="scheduleDateAsDate" filter="date" format="{0:d}"
                       title="{{orderInquiryGridColumnLbl.scheduleDate}}" [width]="220">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="scheduleDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="jobName"
                       title="{{orderInquiryGridColumnLbl.jobName}}" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="jobNumber"
                       title="{{orderInquiryGridColumnLbl.jobNumber}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="poNumber"
                       title="{{orderInquiryGridColumnLbl.po}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shipTo"
                       title="{{orderInquiryGridColumnLbl.shipTo}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shipFrom"
                       title="{{orderInquiryGridColumnLbl.shipFrom}}">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
  -->
  <ng-template kendoGridNoRecordsTemplate>
  </ng-template>
  <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>-->
</kendo-grid>


<section>
  <kendo-dialog [minWidth]="200" [minHeight]="125" title={{warrantyLblText.relatedSOsLbl?warrantyLblText.relatedSOsLbl:generateWarranty.relatedSOsLbl}} *ngIf="popDialogue" (close)="closeDialogue()">
    <div class="confirmationStyle">
      {{serviceDetails}}
    </div>
  </kendo-dialog>
</section>
